if (!customElements.get('hok-card-image-modal')) {
  customElements.define(
    'hok-card-image-modal',
    class HoKCardImageModal extends ModalDialog {
      show(opener) {
        const button = opener?.matches?.('button') ? opener : opener?.querySelector?.('button');
        const img = this.querySelector('.hok-card-image-modal__image');
        const link = this.querySelector('.hok-card-image-modal__link');
        const footer = this.querySelector('.hok-card-image-modal__footer');

        if (button && img) {
          const { hokCardImageSrc, hokCardImageSrcset, hokCardImageAlt, hokCardImageWidth, hokCardImageHeight } =
            button.dataset;

          if (hokCardImageSrc) img.src = hokCardImageSrc;
          if (hokCardImageSrcset) {
            img.srcset = hokCardImageSrcset.trim();
          } else {
            img.removeAttribute('srcset');
          }
          if (hokCardImageAlt) img.alt = hokCardImageAlt;
          if (hokCardImageWidth) img.width = hokCardImageWidth;
          if (hokCardImageHeight) img.height = hokCardImageHeight;
        }

        if (button && link) {
          const { hokProductUrl, hokProductTitle } = button.dataset;
          const hasProductLink = Boolean(hokProductUrl && hokProductTitle);
          if (hasProductLink) {
            link.href = hokProductUrl;
            link.textContent = hokProductTitle;
          }
          link.hidden = !hasProductLink;
          if (footer) footer.hidden = !hasProductLink;
        }

        super.show(button || opener);
      }
    }
  );
}
